import { Fab, Tooltip } from "@material-ui/core";
import {
    AppMenu,
    AppMenuItem,
    AppVersionChecker,
    Button,
    CogIcon,
    mediator,
    MessageMenuItem,
    PlusIcon,
    PowerOffIcon,
    useAsyncEffect,
    useDeviceSize,
    useRelodeApp,
} from "@relode/core";
import { Routing, UserRole } from "@relode/core/domain";
import classnames from "classnames";
import * as React from "react";
import { Switch } from "react-router";

import { teams } from "../../shared/backend/controllers";
import { AddNewJobConfirmationDialog } from "../../shared/components";
import { AddJobContainer } from "../addJob/addJobContainer";
import { useStyles } from "./app.styles";
import { features, isUserAllowed } from "./appFeatures";
import { AppRoutes } from "./appRoutes";

export const App = () => {
    const classes = useStyles({});
    const device = useDeviceSize();
    const {
        actions: { setTeamPlanFeatures },
        state: {
            currentUser: { role },
            settings: {
                user: { isMenuOpen },
            },
        },
    } = useRelodeApp();

    //to improve user experience, we want to determine team plan features when the app mounts
    //this way, we don't have to make an api call for permissions every time a feature is being used
    useAsyncEffect(async () => {
        const teamPlanFeaturesResponse = await teams.teamService.getTeamPlanFeatures();
        setTeamPlanFeatures(teamPlanFeaturesResponse);
    }, []);

    const handleLogout = () => {
        window.location.href = Routing.Account.SIGNOUT;
    };

    const handleAddJob = () => {
        mediator.send("showAddJob");
    };

    const bodyWrapperClassNames = classnames({
        [classes.bodyWrapper]: true,
        [classes.mobileBodyWrapper]: device === "mobile",
    });

    const renderAddJobButton = () => (
        <span className={classes.contextArea}>
            <Tooltip placement="bottom-start" title="add a job">
                {isMenuOpen ? (
                    <Button
                        id="AddJobButton"
                        data-cy="addJob-MenuItem"
                        color="default"
                        size="small"
                        variant="contained"
                        onClick={handleAddJob}
                        startIcon={<PlusIcon />}
                        className={classes.addJobButton}
                    >
                        <span>job</span>
                    </Button>
                ) : (
                    <Fab
                        data-cy="addJob-MenuItem"
                        id="addJobButtonFab"
                        color="default"
                        size="small"
                        onClick={handleAddJob}
                    >
                        <PlusIcon />
                    </Fab>
                )}
            </Tooltip>
        </span>
    );

    return (
        <div className={classes.root}>
            <AppMenu
                contextArea={
                    role === UserRole.ClientAdmin ? renderAddJobButton() : null
                }
            >
                {device === "mobile" && role === UserRole.ClientAdmin ? (
                    <AppMenuItem
                        label="add job"
                        id="addJobMenuItem"
                        tooltip="add job"
                        icon={<PlusIcon />}
                        type="menu"
                        action={handleAddJob}
                    />
                ) : null}

                {features.filter(isUserAllowed).map((f, i) => (
                    <AppMenuItem
                        id={f.name}
                        key={i}
                        label={f.name}
                        tooltip={f.tooltip}
                        icon={f.icon}
                        route={f.clickRoute || f.route}
                        type="menu"
                    />
                ))}
                <MessageMenuItem type="system" appContext="client" />
                <AppMenuItem
                    id="settings"
                    label="settings"
                    tooltip="view personal settings like contact and preferences"
                    icon={<CogIcon />}
                    route="/settings"
                    type="system"
                />
                <AppMenuItem
                    id="signOut"
                    label="sign out"
                    tooltip="sign out of Relode"
                    type="system"
                    icon={<PowerOffIcon />}
                    action={handleLogout}
                />
            </AppMenu>
            <div className={bodyWrapperClassNames}>
                <div className={classes.contentView}>
                    <AddJobContainer />
                    <AddNewJobConfirmationDialog />
                    <Switch>
                        <AppRoutes />
                    </Switch>
                </div>
            </div>
            <AppVersionChecker />
        </div>
    );
};
